import React, { FC, useContext, useEffect, useState } from 'react';

import { AuthContext } from 'auth';

import { IPostPaymentsModalContentProps } from '../interfaces';
import { Cancel } from './Cancel';
import { Info } from './Info';

export const PostPaymentModalContent: FC<IPostPaymentsModalContentProps> = ({
  payment,
  onClose,
  type,
  hostName,
  refetch,
  statedPoling,
}) => {
  const {
    data: { permissions },
  } = useContext(AuthContext);
  const [typeContent, setType] = useState<'info' | 'cancel'>('info');

  useEffect(() => {
    if (!permissions) return;

    if (!permissions.has('payment_create')) setType('cancel');
  }, [permissions]);

  return (
    <>
      {typeContent === 'info' && (
        <Info
          payment={payment}
          setType={() => setType('cancel')}
          onClose={onClose}
          type={type}
          hostName={hostName}
          refetch={refetch}
          statedPoling={statedPoling}
        />
      )}
      {typeContent === 'cancel' && (
        <Cancel
          payment={payment}
          setType={() => setType('info')}
          onClose={onClose}
          type={type}
          hostName={hostName}
          refetch={refetch}
          statedPoling={statedPoling}
        />
      )}
    </>
  );
};
